import React from "react";
import { useState,useEffect,useRef } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/PaymentsReport.css';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import Loading from './Loading';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
 import { format } from "date-fns";

    const columns = [
    {
    field: 'order_id',
    headerName: 'Order ID',
    cellClassName:'order_id_column',headerClassName:'order_id_header',  
    flex:1,  
    sortable:false,
    renderCell: (params) => (
         <div dangerouslySetInnerHTML={{ __html: params.row.order_id }} />
    ),
    
  },
  {
    field: 'first_name',
    headerName: 'First Name',  
    headerClassName:'first_name_header',    
    flex:1,
    sortable:false,
  },
  {
    field: 'last_name',
    headerName: 'Last Name',    
    headerClassName:'last_name_header',
    flex:1,
    sortable:false,
  },
    {
    field: 'email',
    headerName: 'EMail',
    cellClassName:'email_column',headerClassName:'email_header',   
    flex:1, 
    sortable:false,
    renderCell: (params) => (
        <Link href={params.row.profile_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.email}
        </Link>
    ),
    
  },
  {
    field: 'country',
    headerName: 'Country',   
    headerClassName:'country_header',
    flex:1,
    sortable:false,
  },
  {
    field: 'salesperson',
    headerName: 'Salesperson',
    headerClassName:'salesperson_header',   
    flex:1,
    sortable:false,
  },
  {
    field: 'product',
    headerName: 'Product Purchased',   
    headerClassName:'product_purchased_header',
    flex:1,
    sortable:false,
  },
  {
    field: 'amount',
    headerName: 'Amount Paid',   
    headerClassName:'amount_paid_header',
    flex:1,
    sortable:false,
  },

  {
    field: 'payment_method',
    headerName: 'Payment Method',  
    headerClassName:'payment_method_header', 
    flex:1,
    sortable:false,
  },
  {
    field: 'payment_date',
    headerName: 'Payment Date',
    headerClassName:'payment_date_header',   
    flex:1,
    sortable:false,
  },

];

const PaymentsReport = () => {
    const initialPaymentsReportForm = () => {
       const params = new URLSearchParams(window.location.search);
       const defaultForm = {
        start_date:'',
        start_date_obj:null,
        end_date:'',
        end_date_obj:null,
        salesperson:'',
        number_of_courses:'',
        payment_method:'',
        view: '',
        action:''
    };
    const queryStart = params.get("start_date");
    const queryEnd = params.get("end_date");

    // const startObj =
    //   queryStart && !isNaN(new Date(queryStart))
    //     ? new Date(queryStart + "T00:00:00")
    //     : null;

    // const endObj =
    //   queryEnd && !isNaN(new Date(queryEnd))
    //     ? new Date(queryEnd + "T00:00:00")
    //     : null;
    const startObj =
  queryStart
    ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
    : null;

const endObj =
  queryEnd
    ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
    : null;
    const queryView = params.get("view") || '';
         return {
    ...defaultForm,
    start_date: startObj ? queryStart : '',
    start_date_obj: startObj,

    end_date: endObj ? queryEnd : '',
    end_date_obj: endObj,

    salesperson: params.get("salesperson") || defaultForm.salesperson,
    number_of_courses: params.get("number_of_courses") || defaultForm.number_of_courses,
    payment_method: params.get("payment_method") || defaultForm.payment_method,
    view: queryView,
    action:''
  };
};
    //  const [appliedFormData, setAppliedFormData] = useState({
    //     start_date:'',
    //     end_date:'',
    //     salesperson:'',
    //     number_of_courses:'',
    //     payment_method:'',
    //   });
    const [appliedFormData, setAppliedFormData] = useState(initialPaymentsReportForm());
    const [isLoading, setIsLoading] = useState(true);
    const [total, setTotal] = useState(0.00);
    const [formData, setFormData] = useState(initialPaymentsReportForm());
    const [formErrors, setFormErrors] =useState({});
    const[salespersonList, setSalespersonList] = useState({});
    const [submittedData, setSubmittedData] = useState(null);
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [isSubmitted, setIsSubmitted] = useState(false);
// const startDate = new Date(formData.start_date).toLocaleDateString('en-US');
// const endDate = new Date(formData.end_date).toLocaleDateString('en-US');
const parseDateOnly = (dateString) => {
  if (!dateString) return null;

  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day); // local midnight
};

// const startDate = submittedData?.start_date
//   ? new Date(submittedData.start_date).toLocaleDateString('en-US')
//   : '';
// const endDate = submittedData?.end_date
//   ? new Date(submittedData.end_date).toLocaleDateString('en-US')
//   : '';
const startDate = submittedData?.start_date
  ? parseDateOnly(submittedData.start_date).toLocaleDateString('en-US')
  : '';

const endDate = submittedData?.end_date
  ? parseDateOnly(submittedData.end_date).toLocaleDateString('en-US')
  : '';
      const startDateRef = useRef(null);
const endDateRef = useRef(null);

    const app_url = configData.APP_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
  // const handleDateChange = (name, date) => {
  //   const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: formattedDate
  //   }));
  // };
     const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // for DatePicker
    [field]: date ? format(date, 'yyyy-MM-dd') : '' // for backend
  }));
};

   
    useEffect(() => {
           Promise.all([
          getsalespersonlist()
          ]).then(() => {
     
            setIsLoading(false);
          })
        }, []);
    async function getsalespersonlist() {
        try {
            const response = await fetch(
                app_url+'user/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }    
    }
 
    React.useEffect(() => {
      
      if (appliedFormData.start_date || appliedFormData.end_date) {
          const fetchData = async () => {
          // Simulate API call to your server
          // In a real application, replace this with your actual fetch logic
           try {
            setIsLoading(true);
          const response = await fetch(app_url+'report/paymentsreport', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              page: paginationModel.page,
              pageSize: paginationModel.pageSize,
              sortModel,
              filterModel,
              //formData:formData
              // formData:appliedFormData,
              //action: appliedFormData.action
              formData: {
            ...appliedFormData,
            action: isSubmitted ? 'submit' : ''
          }
            }),
          });
          const data = await response.json();
          console.log(data.data.rows);
          setRows(data.data.rows);
          setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          setTotal(data.data.overall_total);
          }  catch (error) {
                console.error('Error fetching data:', error);
              } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
                //   setTimeout(() => {
                //   isFetching.current = false;
                // }, 100);
                    if (isSubmitted) {
                  setIsSubmitted(false);
                }
              }
              
        };
        
    
        fetchData();
      }
          }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change

    const numberofCourses = [
        { value:"", label: "Select"},
        { value:"2", label: "2 courses"},
        { value:"3", label: "3 courses"},
        { value:"4", label: "4 courses"},
        { value:"5", label: "5 or more courses"}
    ];

    const paymentMethod = [
        { value:"", label: "All"},
        { value:"sezzle", label: "Sezzle"},
        { value:"authnet_aim", label: "Credit Card"},
        { value:"paypal_wps", label: "Paypal"}
    ];
  //   const formatDate = (date) => {
  // const year = date.getFullYear();
  // const month = String(date.getMonth() + 1).padStart(2, '0');
  // const day = String(date.getDate()).padStart(2, '0');
  // return `${year}-${month}-${day}`;
  //   };
  const formatDate = (date) => {
  if (!date) return '';

  // Normalize to LOCAL midnight to avoid timezone shift
  const localDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );

  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, '0');
  const day = String(localDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

//     const handleSetData = (event,filterName) => {
//          event.preventDefault();
//         let newFormData;
//          if(filterName == "This month") {
             
//            const currentDate = new Date();
//             const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
//             const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
//             const startDate = formatDate(firstDayOfMonth);
//             const endDate = formatDate(currentDate);
//             newFormData = { ...formData, 'start_date': startDate, 'end_date': endDate };
//              setFormData(prev => ({ ...prev, 'start_date': startDate, 'end_date': endDate }));
//              handleSubmitWithNewData(event, newFormData);
//               setFormErrors({});
//          } 
//          if(filterName == "Last month") {
//             const currentDate = new Date();
//             const lastMonthStartDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
//             const lastMonthEndDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
//             const startDate = formatDate(lastMonthStartDate);
//             const endDate = formatDate(lastMonthEndDate);
//            newFormData = { ...formData, 'start_date': startDate, 'end_date': endDate };
//             setFormData(prev => ({ ...prev, 'start_date': startDate, 'end_date': endDate }));
//              handleSubmitWithNewData(event, newFormData);
//               setFormErrors({});
//          } 
        
  
// };
const handleSetData = (event, filterName) => {
  event.preventDefault();

  const today = new Date();
  let startObj = null;
  let endObj = null;

  if (filterName === "This month") {
    startObj = new Date(today.getFullYear(), today.getMonth(), 1);
    endObj = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  }

  if (filterName === "Last month") {
    startObj = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    endObj = new Date(today.getFullYear(), today.getMonth(), 0);
  }

  if (!startObj || !endObj) return;

  const newFormData = {
    ...initialPaymentsReportForm(),
    start_date_obj: startObj,               //  for DatePicker
    end_date_obj: endObj,                   //  for DatePicker
    start_date: formatDate(startObj),       //  for backend
    end_date: formatDate(endObj)
  };

  setFormData(newFormData);
  setFormErrors({});
  handleSubmitWithNewData(event, newFormData);
};

    // Validation function
const validateDates = (formData) => {
  let errors = {};

  if (!formData.start_date) {
    errors.start_date = "Start date is required.";
  }

  if (!formData.end_date) {
    errors.end_date = "End date is required.";
  }

  if (formData.start_date && formData.end_date) {
    if (formData.end_date < formData.start_date) {
      errors.end_date = "Start date can't over end date.";
    }
  }

  return errors;
};
    // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload
      const errors = validateDates(formData);

  if (Object.keys(errors).length > 0) {
    console.log("Validation errors:", errors);
    setFormErrors(errors); 
    return;
  }
   setFormErrors({});
    setSubmittedData(formData);
    setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
    setIsSubmitted(true);
    setAppliedFormData({ ...formData});
    //  try {
    //     setIsLoading(true);
    //   const response = await fetch(app_url+'report/paymentsreport', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //       page: 0,
    //       pageSize: 50,
    //       sortModel,
    //       filterModel,
    //       formData:formData
    //     }),
    //   });
    //   const data = await response.json();
    //   console.log(data.data.rows);
    //   setRows(data.data.rows);
    //   setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    //   setTotal(data.data.overall_total);
    //   }  catch (error) {
    //         console.error('Error fetching data:', error);
    //       } finally {
    //         setIsLoading(false); // Set loading to false after fetch completes (success or error)
    //       }
    // console.log("Form submitted:", formData);


  };
  const handleSubmitWithNewData = async (event, formData) => {
  event.preventDefault(); // stop page reload
    
    setSubmittedData(formData);
    setPaginationModel({
      page: 0,
      pageSize: 50,
    });
    setIsSubmitted(true);
    setAppliedFormData({ ...formData });
    //  try {
    //     setIsLoading(true);
    //   const response = await fetch(app_url+'report/paymentsreport', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //       // page: paginationModel.page,
    //       // pageSize: paginationModel.pageSize,
    //       page: 0,
    //       pageSize: 50,
    //       sortModel,
    //       filterModel,
    //       formData:formData
    //     }),
    //   });
    //   const data = await response.json();
    //   console.log(data.data.rows);
    //   setRows(data.data.rows);
    //   setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    //   setTotal(data.data.overall_total);
    //   }  catch (error) {
    //         console.error('Error fetching data:', error);
    //       } finally {
    //         setIsLoading(false); // Set loading to false after fetch completes (success or error)
    //       }
    // console.log("Form submitted:", formData);
};
  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
          const errors = validateDates(formData);

  if (Object.keys(errors).length > 0) {
    console.log("Validation errors:", errors);
    setFormErrors(errors); 
    return;
  }
   setFormErrors({});
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'report/paymentsreportexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:formData
        }),
      });
        const data = await response.json();
      const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
const submitFormData = async (data) => {
  setSubmittedData(data);
  setAppliedFormData(data);
  setIsSubmitted(false);
};

useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  if ([...params.keys()].length > 0) {
    const init = initialPaymentsReportForm();

    setFormData(init);

    submitFormData(init);              
  }
}, []);
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="payments-report-main">
                    <Helmet><title>Payments Report</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                      <h1>Payments Report</h1>
                        <div>
                            <div className="payments-report-container">
                                <div className="messages warning">
                                    <strong>This report includes:</strong>
                                    <p>&nbsp;&nbsp;- This report only includes Courses Payments, it does not include courses payments that were collected as "Miscellaneous Charges".</p>
                                    <p>&nbsp;&nbsp;- Data available starting May 2003</p>
                                    <p>&nbsp;&nbsp;- If you're looking up large amounts of data, please wait for the report to load.</p>
                                    <p>&nbsp;&nbsp;- If your search is not successful (i.e. system crashes), try narrowing the search.</p>
                                </div>
                                <form>
                                    <div className="pay-rprt-form-item">
                                        <label htmlFor="start-date">Start Date:</label>
                                        <DatePicker
                                          ref={startDateRef}
                                            selected={formData.start_date_obj}
                                            onChange={(date) => {handleDateChange(date, 'start_date');
                                                  setTimeout(() => {
                                                const input = startDateRef.current?.input;
                                                if (input) {
                                                  const len = input.value.length;
                                                  input.setSelectionRange(len, len);
                                                }
                                              }, 0);
                                            }}
                                            dateFormat="MM/dd/yyyy"
                                            id="start-date"
                                            name="start_date"
                                            className="payment-report-date-field"
                                            // required
                                        />
                                            {formErrors.start_date && (
                                                <div className="error">{formErrors.start_date}</div>
                                                )} 
                                    </div>
                                    <div className="pay-rprt-form-item">
                                        <label htmlFor="end-date">End Date:</label>
                                        <DatePicker
                                        ref={endDateRef}
                                            selected={formData.end_date_obj}
                                            onChange={(date) => {handleDateChange(date, 'end_date');
                                                  setTimeout(() => {
                                                  const input = endDateRef.current?.input;
                                                  if (input) {
                                                    const len = input.value.length;
                                                    input.setSelectionRange(len, len);
                                                  }
                                                }, 0);
                                            }}
                                            dateFormat="MM/dd/yyyy"
                                            id="end-date"
                                            name="end_date"
                                            className="payment-report-date-field"
                                            // required
                                        />
                                        	  {formErrors.end_date && (
                                                <div className="error">{formErrors.end_date}</div>
                                                )}
                                    </div>
                                    <div className="pay-rprt-form-item">
                                    <label htmlFor="salesperson">Salesperson:</label>
                                        <select 
                                            id="salesperson" 
                                            name="salesperson" 
                                            style={{width:"300px", border:"1px solid #ccc", padding: "2px"}}
                                            onChange={handleChange}
                                            value={formData.salesperson}
                                        >
                                            <option value="ALL">ALL</option>
                                            {salespersonList.length > 0 && (
                                                <>
                                                    {salespersonList.map((item, index) => {
                                                        return <>
                                                            {item['uid'] != null && (
                                                                <><option value={item['uid']}>{item['name']}</option></>
                                                            )}
                                                        </>
                                                    })}  
                                                </>
                                            )}
                                             <option value="1472">Lynn Lashbrook</option>
                                              <option value="Unassigned">Unassigned</option>
                                        </select>
                                    </div>
                                    <div className="pay-rprt-form-item">
                                        <label htmlFor="number_of_courses">Number of Courses</label>
                                        <select 
                                            id="number_of_courses" 
                                            name="number_of_courses" 
                                            style={{width:"300px", border: "1px solid #ccc",padding: "2px"}}
                                            onChange={handleChange}
                                            value={formData.number_of_courses}
                                        >
                                            {numberofCourses.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="pay-rprt-form-item">
                                        <label htmlFor="payment_method">Payment Method</label>
                                        <select 
                                            id="payment_method" 
                                            name="payment_method" 
                                            style={{width:"300px",border:"1px solid #ccc",padding: "2px"}}
                                            onChange={handleChange}
                                            value={formData.payment_method}
                                        >
                                            {paymentMethod.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select> 
                                    </div>
                                    <div>
                                    <input type="submit" name="" value="submit" className="form-submit" onClick={handleSubmit}/> 
                                    <input type="button" name="" value="export" className="form-submit" onClick={handleExport}/>
                                    </div>
                                </form>
                                <a style={{cursor:'pointer'}} onClick={(e) => handleSetData(e,"Last month")}>Last Month</a>
                                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <a style={{cursor:'pointer'}} onClick={(e) => handleSetData(e,"This month")}>This Month</a>
                            </div>
                            {submittedData && (
                                <>
                                    <div>
                                        <h1>Total Payment History for:{startDate} to {endDate}</h1>
                                        <div id="total_apps">Overall Total: {total}</div>
                                        <div id="total_apps" style={{marginRight:"2%",width:"230px"}}>Total Apps: {rowCount}</div>
                                    </div>
                                    <div className="payments-report-content">
                                        <table className="payments-report-table">
                                            <div>
                                                <DataGrid
                                                    rows={rows}
                                                    columns={columns}
                                                    rowCount={rowCount}
                                                    paginationMode="server"
                                                    sortingMode="server"
                                                    filterMode="server"
                                                    paginationModel={paginationModel}
                                                    onPaginationModelChange={setPaginationModel}
                                                    sortModel={sortModel}
                                                    onSortModelChange={setSortModel}
                                                    filterModel={filterModel}
                                                    onFilterModelChange={setFilterModel}
                                                    pageSizeOptions={[5, 10, 25,50]}
                                                    getRowId={() => crypto.randomUUID()}
                                                    getRowHeight={() => 'auto'}
                                                    disableColumnFilter 
                                                    //disableColumnResize={true}
                                                />
                                            </div>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};
export default PaymentsReport;